// This value is closed to what browsers are using internally to
// trigger a native scroll.
export const UNCERTAINTY_THRESHOLD = 3; // px

export const SELECTION_ENTERING_THRESHOLD_RATE = 0.1;
